import { TFunction } from 'i18next'
import { UserInvitationModel } from 'src/Libs/installation-rights-management/models'
import { ApiInviteType } from 'src/Libs/api/types'

export const getInvitationMessage = (invitations: UserInvitationModel[], t: TFunction): string => {
  if (invitations.length === 0) return t('installation.invitation.not-found')
  if (invitations.length > 1) return t('installation.invitation.multi-invitation-text')

  const invitation = invitations[0]
  const installationName = invitation.projectName ?? invitation.partnersInstallationName
  const params = { installationId: invitation.installationId, installationName }

  switch (invitation.inviteType) {
    case ApiInviteType.handover:
      return installationName ? t('installation.invitation.handover-text.with-details', params) : t('installation.invitation.handover-text', params)
    case ApiInviteType.handoverPlanned:
      return installationName
        ? t('installation.invitation.handover-planned-text-with-details', params)
        : t('installation.invitation.handover-planned-text', params)
    default:
      return installationName ? t('installation.invitation.text-with-details', params) : t('installation.invitation.text')
  }
}
